const w = window as any;

export const BACKEND_URL =
  w.DeleteUsersConfig?.BACKEND_URL ?? "http://localhost/a_a3/";

export const SESSION_TOKEN_KEY = "admin::gm_session_id";

export const SUPPORTED_LANGUAGES = [
  { value: "no", label: "Norsk" },
  { value: "en", label: "English" },
];
